import { render, staticRenderFns } from "./CreateServiceTicket.vue?vue&type=template&id=b27d1aec&"
import script from "./CreateServiceTicket.vue?vue&type=script&lang=js&"
export * from "./CreateServiceTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports